/**
 * Alert redux that a lazy loaded resource has complete
 */
export const ASYNC_RESOURCE_LOADED = 'ASYNC_RESOURCE_LOADED';

/**
 * The game that the user is viewing has changed
 */
export const GAME_SELECTED = 'GAME_SELECTED';

export const GAME_CONTINUE = 'GAME_CONTINUE';

export const GAME_TIMELIMIT = 'GAME_TIMIELMIT';

/**
 * The game that the user is viewing has changed but its ID is invalid
 */
export const INVALID_GAME_SELECTED = 'INVALID_GAME_SELECTED';
